export default __webpack_public_path__ + "static/media/1-1-1.f1fa45ee.webp";